import { styled } from "@mui/material/styles";
import { InternalLink } from "../Link";

export const EmailLink = styled(InternalLink)(({ theme }) =>
	theme.unstable_sx({
		overflowWrap: "anywhere",
	}),
);
